import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination-area d-flex flex-wrap mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center gap-3"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "ms-auto"
}
const _hoisted_4 = { class: "pagination mb-0 d-flex align-items-baseline" }
const _hoisted_5 = { class: "page-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-double-left" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "page-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-left" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "page-item" }
const _hoisted_12 = { class: "mx-1" }
const _hoisted_13 = { class: "page-item" }
const _hoisted_14 = { class: "page-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-right" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "page-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-double-right" }, null, -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.count !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", {
          class: "mb-0 text-paragraph",
          innerHTML: _ctx.page !== undefined ? _ctx.$t('feature.lists.result_count_range', {
            start: _ctx.start,
            end: _ctx.end,
            total: _ctx.totals
        }) : _ctx.$t('feature.lists.result_total', {
            count: _ctx.count ?? 0
        })
        }, null, 8 /* PROPS */, _hoisted_2),
        (_ctx.page !== undefined)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["page-link", [{ 'disabled': _ctx.currentPage === 1, 'cursor-pointer': _ctx.prevEnabled }]]),
                    "aria-label": "First",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', 1)))
                  }, [..._hoisted_7], 2 /* CLASS */)
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["page-link", [{ 'disabled': !_ctx.prevEnabled, 'cursor-pointer': _ctx.prevEnabled }]]),
                    "aria-label": "Previous",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', _ctx.currentPage - 1)))
                  }, [..._hoisted_10], 2 /* CLASS */)
                ]),
                _createElementVNode("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: "page-link active cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change', _ctx.currentPage)))
                  }, _toDisplayString(_ctx.currentPage), 1 /* TEXT */)
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('feature.lists.out_of')), 1 /* TEXT */),
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["page-link cursor-pointer", [{ 'disabled': !_ctx.nextEnabled, 'cursor-pointer': _ctx.nextEnabled }]]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change', _ctx.pages)))
                  }, _toDisplayString(_ctx.pages), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["page-link", [{ 'disabled': !_ctx.nextEnabled, 'cursor-pointer': _ctx.nextEnabled }]]),
                    "aria-label": "Next",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change', _ctx.currentPage + 1)))
                  }, [..._hoisted_16], 2 /* CLASS */)
                ]),
                _createElementVNode("li", _hoisted_17, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["page-link", [{ 'disabled': _ctx.currentPage === _ctx.pages, 'cursor-pointer': _ctx.nextEnabled }]]),
                    "aria-label": "Last",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('change', _ctx.pages)))
                  }, [..._hoisted_19], 2 /* CLASS */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}